export enum ForumQueryKeys {
  GET_CATEGORIES = 'GET_CATEGORIES',
  GET_TOPICS = 'GET_TOPICS',
  GET_TOPIC = 'GET_TOPIC',
  GET_VOTE_STATUS = 'GET_VOTE_STATUS',
  GET_INFINITE_FORUM_POSTS = 'GET_INFINITE_FORUM_POSTS',
  CHECK_GROUP_ACCESS = 'CHECK_GROUP_ACCESS',
  GET_FORUM_DIGEST_SETTINGS = 'GET_FORUM_DIGEST_SETTINGS',
  GET_USER_FORUM_ACTIVITY = 'GET_USER_FORUM_ACTIVITY',
  GET_USER_FORUM_POSTS = 'GET_USER_FORUM_POSTS',
  GET_USER_FORUM_COMMENTS = 'GET_USER_FORUM_COMMENTS',
}
